import { css } from '@emotion/core';

const lineHeight = 48;

const highlightRowStyles = theme => css`
  background-color: ${theme.variables.colors.action.primary.default};
  color: white !important;
  fill: white !important;
`;

const selectedRowStyles = theme => css`
  background-color: ${theme.variables.colors.action.primary.light};
  color: white !important;
`;

const disabledRowStyles = theme => css`
  background-color: white !important;
  cursor: default;
  ${theme.classes.typography.color.misc.medium} !important
`;

const anchorPositions = ({ horizontal, vertical }) => `
${vertical === 'top' ? 'bottom: 100%;' : 'top: 100%;'}
${horizontal !== 'right' && horizontal !== 'left' ? 'left: 50%;' : ''}
${horizontal === 'right' ? 'right: 0;' : ''}
${horizontal === 'left' ? 'left: 0;' : ''}

  ${
    horizontal === 'left' || horizontal === 'right'
      ? 'transform: translateX(0);'
      : 'transform: translateX(-50%);'
  }
`;

export default ({
  anchorOffset,
  isSelected,
  isHighlighted,
  isCustomSectionHeader,
  isDisabled,
  dropdownWidth,
  theme
}) => ({
  body: css`
    flex-direction: column;
    align-items: stretch;
    background: white;

    position: absolute;
    z-index: 999;
    font-size: 1rem;
    ${anchorOffset ? anchorPositions(anchorOffset) : ''}

    border: 1px solid #ddd;
    max-width: ${dropdownWidth};
    width: ${dropdownWidth};
    border-radius: 3px;
    box-shadow: 0 0 4 px rgba(180, 180, 198, 0.4);
    padding-bottom: 1px;
    padding-top: 0px;
  `,
  listItem: css`
    font-weight: 500;
    cursor: pointer;
    padding: ${isCustomSectionHeader ? '0px' : '14px 10px'};
    text-align: left;
    min-height: ${lineHeight}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(34, 34, 34, 1);
    ${isSelected ? selectedRowStyles(theme) : ''}
    ${isHighlighted ? highlightRowStyles(theme) : ''}
    ${isDisabled ? disabledRowStyles(theme) : ''}
    .visa-ui-checkbox+.visa-ui-checkbox-label {
      ${isHighlighted ? highlightRowStyles(theme) : ''}
    }
    .visa-ui-icon use,
    .visa-ui-icon--low use {
      ${isHighlighted ? highlightRowStyles(theme) : ''}
    }
  `,
  list: css`
    max-height: ${lineHeight * 8}px;
    overflow: auto;
    padding-left: 0;
    margin-top: 0px;
    margin-bottom: 0px;
  `,
  wrapper: css`
    position: relative;
    width: fit-content;
  `
});
